// import { useParams } from 'next/navigation';
import { SVGProps } from 'react';

const FavoritesVector = (props: SVGProps<SVGSVGElement>) => {
  // const { section } = useParams<{ section?: string }>();
  // const sectionValue = section?.toLowerCase();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      viewBox="0 0 24 24"
      fill="none"
      // stroke={sectionValue === 'woman' || !sectionValue ? '#fff' : '#000'}
      {...props}
    >
      <path d="M11.1554 20.1916L11.1547 20.1909C8.3383 17.637 6.04084 15.5502 4.44163 13.5937C2.84791 11.6438 2 9.88467 2 7.99455C2 4.90344 4.41315 2.5 7.49455 2.5C9.23986 2.5 10.9232 3.31506 12.0198 4.59267L12.3992 5.03474L12.7786 4.59267C13.8751 3.31506 15.5585 2.5 17.3038 2.5C20.3852 2.5 22.7984 4.90344 22.7984 7.99455C22.7984 9.88467 21.9505 11.6438 20.3567 13.5937C18.7575 15.5502 16.4601 17.637 13.6437 20.1909L13.643 20.1916L12.3992 21.3238L11.1554 20.1916Z" />
    </svg>
  );
};

export default FavoritesVector;
